import { useEffect, useRef } from 'react';
import type { Feature, Point } from 'geojson';

import { pointToFeature } from '../geometry';

type UsePointDrawArgs = {
  map: google.maps.Map | null;
  enabled: boolean;
  onCommit: (feature: Feature<Point>) => void;
};

const usePointDraw = ({ map, enabled, onCommit }: UsePointDrawArgs) => {
  const onCommitRef = useRef(onCommit);
  onCommitRef.current = onCommit;

  useEffect(() => {
    if (!map || !enabled) {
      return undefined;
    }

    const click = map.addListener(
      'click',
      (event: google.maps.MapMouseEvent) => {
        if (event.latLng) {
          onCommitRef.current(
            pointToFeature({
              lat: event.latLng.lat(),
              lng: event.latLng.lng(),
            }),
          );
        }
      },
    );

    return () => click.remove();
  }, [map, enabled]);
};

export default usePointDraw;
